export default __webpack_public_path__ + "static/media/bsc.aa885665.webp";